module.exports = __webpack_public_path__ + "static/img/bsb.622ec4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/bsb.png
// module id = JXp+
// module chunks = 93